import Usuario from "../usuario/Usuario";
import Auth0Service from "../auth0/Auth0Service";

import AppConfig from "../../AppConfig";
export default class AppContexto {
	public usuario: Usuario;
	public formatador: Formatador;
	public auth0Service: Auth0Service | null = null;

	// react states do App.tsx para tema da aplicação
	public getIsDark: boolean;
	public setIsDark: ((arg0: boolean) => void) | undefined;

	public storage: Storage;

	public constructor() {
		this.storage = window.localStorage;
		this.getIsDark = false;

		if (this.storage.getItem(AppConfig.Storage.Key.isDark)) {
			this.getIsDark = this.storage_isDark();
		}

		this.usuario = new Usuario();
		this.formatador = new Formatador();
	}

	public storage_isDark(): boolean {
		let r = this.storage.getItem(AppConfig.Storage.Key.isDark);
		return JSON.parse(r || "null");
	}

	public storage_isDark_save(bln: boolean): void {
		if (typeof this.setIsDark !== "undefined") {
			this.setIsDark(bln);
			this.storage.setItem(
				AppConfig.Storage.Key.isDark,
				JSON.stringify(bln),
			);
		}
	}

	public setAuth0Service(auth0Service: Auth0Service): void {
		this.auth0Service = auth0Service;
		this.usuario.setAuth0Service(auth0Service);
	}

	public async getAccessToken(): Promise<string | undefined> {
		if (!this.auth0Service) {
			return undefined;
		}
		return await this.auth0Service.getAccessToken();
	}

	// Backward compatibility methods
	public storage_accessToken_save(_token: string): void {
		// Auth0 handles token storage internally
		// Deprecated: storage_accessToken_save is no longer used with Auth0
	}

	public storage_accessToken(): string | null {
		// Auth0 handles token storage internally
		// Deprecated: Use getAccessToken() instead - cannot get token synchronously with Auth0
		return null;
	}

	public storage_deleteKey(key: string): void {
		this.storage.removeItem(key);
	}

	public logout(): void {
		if (this.auth0Service) {
			this.auth0Service.logout();
		}
	}

	public login(): void {
		if (this.auth0Service) {
			this.auth0Service.loginWithRedirect();
		}
	}
}

class Formatador {
	numero(n: number): string {
		return Intl.NumberFormat("en-US").format(n);
	}
}
